/** @format */

import { ProductSelectionState } from '@pdp/data-access/interfaces';
import { createReducer, on } from '@ngrx/store';
import { appInitializerKillswitchesSet } from './killswitches.actions';

export const killswitchesReducer = createReducer(
  {} as ProductSelectionState['killswitches'],
  on(appInitializerKillswitchesSet, (state, { killswitches }) => ({
    ...killswitches,
  })),
);
